/*
  bb-consent.js — la casella delle condizioni prima della cassa.

  DOVE COMPARE
  Ovunque ci sia un bottone che porta alla cassa: la tendina del carrello (che
  ora e' la strada normale), la pagina /cart per chi ci arriva da un link, e i
  bottoni di pagamento veloce sulla scheda prodotto, che saltano il carrello.
  Quell'ultimo caso e' il buco che rende inutile ogni casella messa solo nel
  carrello: da "Buy with Shop Pay" si va in cassa senza passare da li'.

  COSA SUCCEDE QUANDO SI SPUNTA
  1. il bottone della cassa si riaccende;
  2. la scelta va nel carrello come ATTRIBUTO, quindi finisce sull'ordine
     nell'admin con data, ora e l'elenco delle condizioni accettate.
  Il punto 2 e' quello che serve davvero: una spunta che si limita a sbloccare
  un bottone non lascia traccia, e il giorno del chargeback non prova niente.

  RESTA SPUNTATA?
  No. Si riparte da zero a ogni carrello nuovo, e l'attributo si riscrive con la
  data del momento. Una spunta vecchia di tre settimane non dimostra che il
  cliente abbia letto le condizioni di QUESTO ordine.
*/
(function () {
  'use strict';
  if (window.__bbConsent) return;
  window.__bbConsent = true;

  var ATTR = 'Terms acknowledged';
  /*
    5 ott 2026: frase della casella data da Chris, parola per parola. Sull'ordine
    si registra anche QUALE policy e QUALE versione e' stata accettata (sezione 9
    della policy: vale la versione accettata per quell'ordine).
  */
  var FRASE = 'I have read and agree to BLACKBOOST USA\u2019s Product Compatibility, Installation, Returns & Liability Policy, including the return restrictions, installation responsibilities, check engine light provisions, and applicable liability limitations.';
  var VERSIONE = 'Agreed: Product Compatibility, Installation, Returns & Liability Policy, version 2026-10-05';
  /*
    6 ott 2026, chiesto da Chris: dropship e dazi restano scritti nella casella
    e sull'ordine (non sono nella policy resi, stanno nella shipping policy).
  */
  var PUNTI = [
    'Drop shipped items ship from our manufacturer, take 5 to 7 days and cannot be expedited',
    'Import tariffs and duties are the responsibility of the customer'
  ];
  /*
    5 ott 2026: tolti i cinque punti sotto la casella (30 giorni, non installato,
    20%, dropship, dazi). Sono scritti nelle policy, che ora si aprono in un
    pop-up dalla casella stessa; sulle schede prodotto il dropship resta nel box
    arancione. La casella deve essere piccola e passare quasi inosservata
    (Sebastiano).
  */
  var POLICY = [
    { url: '/policies/refund-policy', nome: 'Returns, Installation &amp; Product Policies' },
    { url: '/policies/shipping-policy', nome: 'Shipping policy' },
    { url: '/policies/terms-of-service', nome: 'Terms of service' }
  ];

  /*
    LINK FUORI DALL'ETICHETTA (1 ott 2026)
    I tre link stavano dentro la <label>: da telefono la frase va su tre righe
    e quasi tutta e' link, quindi il dito finiva su "Shipping policy", si
    apriva una scheda nuova e la casella restava vuota. Ora l'etichetta e' solo
    testo (tocco sulla frase = spunta) e i link stanno su una riga a parte,
    sotto.
  */
  function testo() {
    return (
      '<label class="bb-ack__row">' +
        '<input type="checkbox" class="bb-ack__input" data-bb-ack-input autocomplete="off">' +
        '<span class="bb-ack__box" aria-hidden="true"></span>' +
        '<span class="bb-ack__text">' +
          FRASE.replace(/&/g, '&amp;') +
        '</span>' +
      '</label>' +
      '<p class="bb-ack__note">' + PUNTI.join('. ') + '.</p>' +
      '<p class="bb-ack__links">' +
        POLICY.map(function (x) {
          return '<a href="' + x.url + '" target="_blank" rel="noopener" data-bb-pol>' + x.nome + '</a>';
        }).join('') +
      '</p>' +
      '<p class="bb-ack__warn" data-bb-ack-warn hidden role="alert">' +
        'Please accept the terms before you continue.' +
      '</p>'
    );
  }

  /* Segna sull'ordine chi ha accettato e quando. */
  function registra(spuntato) {
    var valore = spuntato
      ? 'Yes, ' + new Date().toISOString() + ' — ' + VERSIONE + '; ' + PUNTI.join('; ')
      : '';
    var corpo = {};
    corpo[ATTR] = valore;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: corpo })
    }).catch(function () { /* la cassa resta comunque bloccata finche' non si spunta */ });
  }

  function bottoniCassa(dentro) {
    return Array.prototype.slice.call(
      (dentro || document).querySelectorAll(
        '[name="checkout"], .cart__checkout-button, .shopify-payment-button__button, .shopify-payment-button__more-options, .cart__dynamic-checkout-buttons, #dynamic-checkout-cart'
      )
    );
  }

  /*
    IL BACO DEL 14 SET, DA NON RIFARE
    La prima versione agganciava il listener di cattura a ogni monta(), e il
    listener chiudeva sull'input di QUELLA casella. La tendina si ridisegna a ogni
    aggiunta o cambio quantita': la casella vecchia sparisce, il listener vecchio
    resta sul <cart-drawer> (che e' persistente) e legge per sempre un input
    staccato, mai spuntato. Risultato: CHECK OUT bloccato senza avviso, bottone
    che sembra attivo, si sblocca solo ricaricando. Ora il listener si aggancia
    UNA volta per contenitore e cerca la casella al momento del click.
  */
  /*
    STATO PER CONTENITORE, NON GLOBALE
    Sulla scheda prodotto convivono due caselle: quella del drawer e quella sopra
    "Buy with Shop Pay". Con un flag unico, spuntare la seconda e poi aggiungere al
    carrello (il drawer si rimonta) cancellava l'attributo mentre la casella
    prodotto restava spuntata: ordine da Shop Pay senza traccia. Ogni contenitore
    ricorda solo la SUA spunta.
  */
  function caselle(dentro) {
    return (dentro || document).querySelector('[data-bb-ack-input]');
  }

  /*
    IL VALORE VIAGGIA ANCHE DENTRO IL FORM
    registra() scrive l'attributo con una fetch che nessuno aspetta: spunta e
    CHECK OUT nello stesso secondo potevano partire prima che /cart/update.js
    fosse atterrato. Un input nascosto attributes[...] agganciato al form del
    carrello (form="CartDrawer-Form" o form="cart") porta il valore nel POST
    della cassa da solo, fetch o non fetch. Sulla scheda prodotto il form e'
    quello del prodotto e il campo diventa una properties[] della riga: Shop Pay
    e PayPal express partono da li', non dal carrello.
  */
  function campoNascosto(box, dentro, spuntato) {
    var hid = box.querySelector('[data-bb-ack-hidden]');
    if (!hid) {
      hid = document.createElement('input');
      hid.type = 'hidden';
      hid.setAttribute('data-bb-ack-hidden', '');
      var host = dentro || document;
      var formCassa = host.querySelector ? host.querySelector('form[action*="/cart"][id]') : null;
      var formProdotto = box.closest('form[action*="/cart/add"]') || (host.querySelector ? host.querySelector('form[action*="/cart/add"]') : null);
      // getAttribute, non .id: nel form prodotto c'e' un <input name="id"> (la
      // variante) e form.id restituisce QUELL'input invece della stringa.
      var idCassa = formCassa ? formCassa.getAttribute('id') : '';
      // Su /cart il form (#cart) sta in cart-items, non nel piede: il bottone
      // CHECK OUT ci arriva con form="cart". Si prende quello.
      if (!idCassa && host.querySelector) {
        var btnCassa = host.querySelector('[name="checkout"]');
        if (btnCassa && btnCassa.getAttribute('form')) idCassa = btnCassa.getAttribute('form');
      }
      var idProd = formProdotto ? formProdotto.getAttribute('id') : '';
      if (idCassa) { hid.name = 'attributes[' + ATTR + ']'; hid.setAttribute('form', idCassa); }
      // Proprieta' con "_" davanti: Shopify la registra sull'ordine ma non la
      // stampa nel checkout ne' nella conferma. Senza, con "Buy it now" il
      // cliente vedeva sotto il prodotto dieci righe con la data ISO (1 ott 2026).
      else if (formProdotto) { hid.name = 'properties[_' + ATTR + ']'; if (idProd && !box.closest('form')) hid.setAttribute('form', idProd); }
      else { hid.name = 'attributes[' + ATTR + ']'; }
      box.appendChild(hid);
    }
    hid.value = spuntato ? 'Yes, ' + new Date().toISOString() + ' — ' + VERSIONE + '; ' + PUNTI.join('; ') : '';
  }

  function aggiorna(dentro) {
    var input = caselle(dentro);
    var ok = !!(input && input.checked);
    var box = input ? input.closest('.bb-ack') : null;
    if (box) {
      box.classList.toggle('is-done', ok);
      if (ok) { box.classList.remove('is-missing'); var w = box.querySelector('[data-bb-ack-warn]'); if (w) w.hidden = true; }
      campoNascosto(box, dentro, ok);
    }
    bottoniCassa(dentro).forEach(function (b) {
      b.classList.toggle('bb-ack-blocked', !ok);
      b.setAttribute('aria-disabled', String(!ok));
    });
    // lo scudo sui wallet (Shop Pay, PayPal in iframe): sparisce con la spunta
    var host = dentro || document;
    var scudi = host.querySelectorAll ? host.querySelectorAll('[data-bb-ack-shield]') : [];
    for (var i = 0; i < scudi.length; i++) scudi[i].hidden = ok;
  }

  /*
    SCUDO SUI BOTTONI DI PAGAMENTO VELOCE
    "Buy with Shop Pay" e' un bottone vero e il click in cattura lo ferma. Ma se
    il wallet consigliato e' PayPal, e' un iframe: il click nasce dentro
    l'iframe e al documento non arriva mai. Un velo trasparente sopra il
    contenitore prende il click al posto loro finche' la casella non e' spuntata.
  */
  function scudo(bersaglio, dentro) {
    if (!bersaglio || bersaglio.querySelector('[data-bb-ack-shield]')) return;
    var cs = window.getComputedStyle(bersaglio);
    if (cs.position === 'static') bersaglio.style.position = 'relative';
    var v = document.createElement('div');
    v.setAttribute('data-bb-ack-shield', '');
    v.className = 'bb-ack__shield';
    v.setAttribute('aria-hidden', 'true');
    bersaglio.appendChild(v);
  }

  function agganciaCattura(dentro) {
    var host = dentro || document;
    if (host.__bbAckBound) return;
    host.__bbAckBound = true;
    /*
      Il blocco si fa in CATTURA sul contenitore: i bottoni di pagamento veloce
      di Shopify vivono dentro un iframe-like con i loro gestori, e disabilitarli
      con l'attributo "disabled" non funziona su tutti. Fermare il click prima
      che arrivi a loro funziona su tutti.
    */
    host.addEventListener('click', function (e) {
      var b = e.target && e.target.closest
        ? e.target.closest('[name="checkout"], .cart__checkout-button, .shopify-payment-button, .cart__dynamic-checkout-buttons, #dynamic-checkout-cart, [data-bb-ack-shield]')
        : null;
      if (!b) return;
      var input = caselle(host);           // la casella VIVA, non quella di ieri
      /*
        TORNANDO INDIETRO DAL CHECKOUT (1 ott 2026): il browser rimetteva la
        spunta senza far partire 'change', il campo nascosto restava vuoto e
        CHECK OUT passava cancellando "Terms acknowledged". Spuntata ma senza
        valore = non spuntata: si azzera e si chiede di nuovo.
      */
      if (input && input.checked) {
        var boxV = input.closest('.bb-ack');
        var hidV = boxV ? boxV.querySelector('[data-bb-ack-hidden]') : null;
        if (hidV && !hidV.value) { input.checked = false; host.__bbAckTicked = false; aggiorna(dentro); }
      }
      if (!input || input.checked) return;
      e.preventDefault();
      e.stopPropagation();
      var box = input.closest('.bb-ack');
      var warn = box ? box.querySelector('[data-bb-ack-warn]') : null;
      if (box) box.classList.add('is-missing');
      if (warn) warn.hidden = false;
      if (box) box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      input.focus({ preventScroll: true });
    }, true);
  }

  /*
    POP-UP DELLE POLICY (5 ott 2026)
    Un clic su una policy non apre piu' una scheda nuova (il cliente usciva dal
    carrello): si apre un riquadro piccolo con il testo da scorrere e una X.
    Il testo si prende dalla pagina /policies/... del negozio, una volta sola.
    Dal carrello a tendina il riquadro nasce DENTRO <cart-drawer>: Dawn tiene il
    fuoco chiuso nella tendina e lo riporterebbe indietro da un riquadro esterno.
    Senza <dialog> (browser vecchi) o se la pagina non arriva, il link si apre
    come prima in una scheda nuova.
  */
  var testiPolicy = {};
  function apriPolicy(a, dentro) {
    var url = a.getAttribute('href');
    var casa = (dentro && dentro.tagName === 'CART-DRAWER') ? dentro : document.body;
    var dlg = casa.querySelector(':scope > dialog.bb-pol');
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'bb-pol';
      dlg.innerHTML =
        '<div class="bb-pol__head"><p class="bb-pol__title"></p>' +
        '<button type="button" class="bb-pol__x" aria-label="Close">&times;</button></div>' +
        '<div class="bb-pol__body"></div>';
      dlg.querySelector('.bb-pol__x').addEventListener('click', function () { dlg.close(); });
      // clic sul fondo scuro (fuori dal riquadro) = chiudi
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      // Esc chiude il riquadro e basta: la tendina di Dawn si chiude anche lei su Esc
      ['keydown', 'keyup'].forEach(function (ev) {
        dlg.addEventListener(ev, function (e) { if (e.key === 'Escape') e.stopPropagation(); });
      });
      casa.appendChild(dlg);
    }
    var titolo = dlg.querySelector('.bb-pol__title'), corpo = dlg.querySelector('.bb-pol__body');
    titolo.innerHTML = a.innerHTML;
    corpo.innerHTML = '<p class="bb-pol__wait">Loading…</p>';
    dlg.showModal();
    corpo.scrollTop = 0;
    var pronto = testiPolicy[url] ? Promise.resolve(testiPolicy[url]) :
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (h) {
          var doc = new DOMParser().parseFromString(h, 'text/html');
          var b = doc.querySelector('.shopify-policy__body');
          if (!b) throw new Error('niente testo');
          return (testiPolicy[url] = b.innerHTML);
        });
    pronto.then(function (h) { corpo.innerHTML = h; corpo.scrollTop = 0; })
      .catch(function () { dlg.close(); window.open(url, '_blank', 'noopener'); });
  }

  function monta(ancora, dentro) {
    if (!ancora || ancora.parentNode.querySelector('.bb-ack')) return null;
    var host = dentro || document;
    var box = document.createElement('div');
    box.className = 'bb-ack';
    box.setAttribute('data-bb-ack', '');
    box.innerHTML = testo();
    ancora.parentNode.insertBefore(box, ancora);

    Array.prototype.forEach.call(box.querySelectorAll('[data-bb-pol]'), function (a) {
      a.addEventListener('click', function (e) {
        if (typeof HTMLDialogElement !== 'function') return;   // niente <dialog>: scheda nuova
        e.preventDefault();
        apriPolicy(a, dentro);
      });
    });

    var input = box.querySelector('[data-bb-ack-input]');
    input.addEventListener('change', function () {
      host.__bbAckTicked = input.checked;
      aggiorna(dentro);
      registra(input.checked);
    });

    // Casella nuova = non spuntata. Se QUESTO contenitore era stato spuntato
    // prima (il drawer si e' ridisegnato), l'attributo sul carrello va azzerato:
    // una spunta vecchia non vale per questo carrello. Gli altri contenitori
    // non c'entrano.
    if (host.__bbAckTicked) { host.__bbAckTicked = false; registra(false); }

    // wallet veloci: scudo sul contenitore, cosi' anche l'iframe di PayPal e' coperto
    var wallet = host.querySelector ? host.querySelector('.shopify-payment-button, .cart__dynamic-checkout-buttons, #dynamic-checkout-cart') : null;
    if (wallet) scudo(wallet, dentro);

    agganciaCattura(dentro);
    aggiorna(dentro);
    return box;
  }

  function giro() {
    // 1. tendina del carrello
    var tendina = document.querySelector('cart-drawer');
    if (tendina) {
      var cta = tendina.querySelector('.cart__ctas, [name="checkout"]');
      if (cta) monta(cta.closest('.cart__ctas') || cta, tendina);
    }
    // 2. pagina /cart, per chi ci arriva da un link. Il piede (.cart__footer)
    //    PRIMA di cart-items: cart-items viene prima nel documento ma non ha il
    //    bottone, e la casella non veniva mai montata.
    var pagina = document.querySelector('.cart__footer') || document.querySelector('cart-items');
    if (pagina) {
      var cta2 = pagina.querySelector('.cart__ctas, [name="checkout"]');
      if (cta2) monta(cta2.closest('.cart__ctas') || cta2, pagina);
    }
    // 3. pagamento veloce sulla scheda prodotto: salta il carrello
    var veloce = document.querySelector('.shopify-payment-button');
    if (veloce) monta(veloce, veloce.closest('.product-form__buttons') || document);
  }

  /*
    PAGINA RIPRESA CON "INDIETRO" (bfcache): lo stato JS e' quello di prima del
    checkout, la spunta pure, ma l'attributo sul carrello puo' essere cambiato.
    Si riparte puliti: caselle vuote, campo vuoto, cassa bloccata (1 ott 2026).
  */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-bb-ack-input]'), function (inp) {
      if (!inp.checked) return;
      inp.checked = false;
      var h = inp.closest('cart-drawer') || inp.closest('.cart__footer') || inp.closest('cart-items') ||
              inp.closest('.product-form__buttons') || document;
      h.__bbAckTicked = false;
      aggiorna(h === document ? null : h);
      registra(false);
    });
  });

  /*
    PAYPAL DA TASTIERA (1 ott 2026): lo scudo ferma il mouse, ma con Tab si
    entrava nell'iframe di PayPal e Invio apriva il pagamento senza spunta. Finche'
    la casella non e' spuntata i bottoni dei wallet sono inert: niente fuoco,
    niente click. Si riapplica a ogni giro perche' Shopify li disegna in ritardo.
  */
  function wallets() {
    var host, sel = '.shopify-payment-button, .cart__dynamic-checkout-buttons, #dynamic-checkout-cart';
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (w) {
      host = w.closest('cart-drawer') || w.closest('.cart__footer') || w.closest('.product-form__buttons') || document;
      var input = caselle(host === document ? null : host);
      if (!input) return;
      var ok = !!input.checked;
      // sulla scheda prodotto anche anno/modello e targhetta devono esserci
      // (28 ott 2026: "Buy now" con Shop Pay partiva con i campi vuoti)
      if (ok && w.closest('.product-form__buttons') && window.__bbPlateVuoto && window.__bbPlateVuoto()) ok = false;
      Array.prototype.forEach.call(w.children, function (c) {
        if (c.hasAttribute('data-bb-ack-shield')) return;
        if (ok && c.hasAttribute('inert')) c.removeAttribute('inert');
        if (!ok && !c.hasAttribute('inert')) c.setAttribute('inert', '');
      });
    });
  }

  function avvia() {
    giro();
    wallets();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('[data-bb-ack-input]')) wallets();
    });
    document.addEventListener('bb:plate', wallets);
    // la tendina si ridisegna a ogni aggiunta: la casella va rimessa
    var mo = new MutationObserver(function () { giro(); wallets(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
